* {
    font-family: SourceSansPro;
}

@font-face {
    font-family: "SourceSansPro";
    font-weight: 300;
    src: url("SourceSansPro-Light.ttf");
}

@font-face {
    font-family: "SourceSansPro";
    font-weight: 400;
    src: url("SourceSansPro-Regular.ttf");
}

@font-face {
    font-family: "SourceSansPro";
    font-weight: 500;
    src: url("SourceSansPro-SemiBold.ttf");
}

@font-face {
    font-family: "SourceSansPro";
    font-weight: 600;
    src: url("SourceSansPro-Bold.ttf");
}
